<template>
  <div id="app">
    <app-wrapper></app-wrapper>
  </div>
</template>

<script>
import AppWrapper from './components/AppWrapper';

export default {
  name: 'App',
  components: {
    AppWrapper,
  },
};
</script>

<style lang="scss">
*,
*:before,
*:after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  user-select: none;
}
html,
body {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

#app {
  font-family: 'Rubik', sans-serif, Helvetica, Arial;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
  background: $primary-bg-color;
  color: $primary-text-color;
}
</style>
